import { EventTypes } from './EventType';

export enum DemographicInsightPresentationMode {
  TableAndChart = 'TableAndChart',
  Table = 'Table',
}

export enum BehavioralInsightPresentationMode {
  Rate = 'Rate',
  TotalCount = 'TotalCount',
}

export type DemographicSettings = {
  contactProperty: string;
  presentationMode: DemographicInsightPresentationMode;
};

export type BehavioralSettings = {
  eventName: string;
  presentationMode: BehavioralInsightPresentationMode;
  dataType: EventTypes;
};
